import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'dpqa-tooltip-with-title',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './tooltip-with-title.component.html',
  styleUrl: './tooltip-with-title.component.less',
})
export class TooltipWithTitleComponent {
  public titleKey = input.required<string>();
  public bodyKey = input.required<string>();
}
